import { render, staticRenderFns } from "./forgotPasswordEdit.vue?vue&type=template&id=4c2dbd80&scoped=true&"
import script from "./forgotPasswordEdit.vue?vue&type=script&lang=js&"
export * from "./forgotPasswordEdit.vue?vue&type=script&lang=js&"
import style0 from "./forgotPasswordEdit.vue?vue&type=style&index=0&id=4c2dbd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2dbd80",
  null
  
)

export default component.exports